import axiosInstance from '../config/axios';

export const getCourses = async () => {
  const res = await axiosInstance.get('/getCourses');
  return res.data;
};

export const getRecommended = async () => {
  const res = await axiosInstance.get('/recommended');
  return res.data;
};

export const getTrending = async () => {
  const res = await axiosInstance.get('/trending');
  return res.data;
};
